// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heading[data-v-56d12d8b] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.theme-selector-theme[data-v-56d12d8b] {\n  display: flex;\n  align-items: center;\n}\n.theme-selector-checkbox[data-v-56d12d8b] {\n  width: 100px;\n  padding-top: 20px;\n}\n.theme-selector-name[data-v-56d12d8b] {\n  width: 85%;\n}\n.theme-selector-delete[data-v-56d12d8b] {\n  margin: 0 auto;\n  cursor: pointer;\n  padding-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
